var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title || _vm.data)?_c('div',{staticClass:"counter"},[(_vm.title)?_c('h3',{staticClass:"counter__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.data)?_c('span',{staticClass:"counter__data"},[_vm._v(" "+_vm._s(_vm.data)+" ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }